import React, { useContext, useState } from "react";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { PortalContext } from "../../../context/Provider";
import { editaTurnosDisponibles } from "../../../context/Actions/turnos/turnosDisponibles";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./FiltrosLabo.css";

const FiltrosLabo = ({ titulo, dissmiss, onHandleBuscarTurnosLabo }) => {
  const { turnosDisponiblesState, turnosDisponiblesDispatch } =
    useContext(PortalContext);
  const [arrayFiltros, setArrayFiltros] = useState([]);
  const idTerminal = getLocalStorage("idTerminal");

  const handleChangeCentros = (e) => {
    let centroArrx =
      turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
        .centrosLabo;

    //manejo el estado de los botones
    if (e.target.id === "0" && !e.target.checked) {
      centroArrx = centroArrx.map((array) => ({ ...array, checked: false }));
    } else if (e.target.id === "0" && e.target.checked) {
      centroArrx = centroArrx.map((array) => ({ ...array, checked: true }));
    } else if (e.target.id !== "0") {
      let objIndex = centroArrx.findIndex(
        (obj) => obj.id.toString() === e.target.id
      );
      centroArrx[objIndex].checked = e.target.checked;
      //no se cumple la funcion de todos. Destildo.
      centroArrx[0].checked = false;
      if (!centroArrx[0].checked) {
        let centroAux = centroArrx.filter((item) => item.checked !== true);
        if (
          centroAux.length === 1 &&
          centroAux.filter((item) => item.id === 0).length > 0
        ) {
          centroArrx[0].checked = true;
        }
      }
    }
    // este editar lo deja vacio sin editar.
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        centrosLabo: centroArrx,
      },
    })(turnosDisponiblesDispatch);
    setArrayFiltros(centroArrx);
  };

  return (
    <React.Fragment>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-filtrosLaboCentro-container">
        <div className="ptur-filtrosLaboCentro-filtrosBox">
          <div className={`ptur-filtrosLaboCentro-checkboxes`}>
            <span className="ptur-filtrosLaboCentro-checkTitle rb16mh">
              Centros disponibles
            </span>
            {turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centrosLabo?.map(
              (item, index) => (
                <label
                  className="ptur-filtrosLaboCentro-checkbox-labelBox"
                  key={index}
                >
                  {item.ubicacion ? (
                    <>
                      <div className="ptur-filtrosLaboCentro-info">
                        <span className="rb16m">{item.descripcion}</span>
                        <div>
                          <a
                            href={!idTerminal && `https://maps.google.com/?q=${item.coordenadas}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {item.ubicacion}
                          </a>
                        </div>
                      </div>
                    </>
                  ) : (
                    <span className="rb16m">{item.descripcion}</span>
                  )}
                  <input
                    type="checkbox"
                    onChange={handleChangeCentros}
                    id={item.id}
                    name={item.descripcion}
                    checked={item.checked}
                    autoComplete="off"
                  />
                  <span className="ptur-filtrosLaboCentro-checkbox-checkmark"></span>
                </label>
              )
            )}
          </div>
        </div>
        <div className="ptur-filtrosLaboCentro-btn-box">
          <button
            className="ptur-filtrosLaboCentro-btnVolver c-latex30 rb16m"
            onClick={dissmiss}
          >
            Volver
          </button>
          <button
            className="ptur-filtrosLaboCentro-btnBuscar c-white rb16m"
            onClick={() => onHandleBuscarTurnosLabo(arrayFiltros)}
          >
            Buscar turnos
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FiltrosLabo;
